module.exports = __webpack_public_path__ + "img/img-41.02114b3f.png";